/**
 * Responsive grid of AppCards. 3-col desktop, 2-col tablet, 1-col mobile.
 */
import { Card, SimpleGrid, Text } from '@mantine/core'
import type { AppHealthSummary } from '../types'
import { AppCard } from './AppCard'

interface Props {
  apps: AppHealthSummary[]
  onSelectApp: (app: AppHealthSummary) => void
  /** slug do app recém-provisionado a destacar (scroll + pulse + NOVO). */
  highlightSlug?: string | null
}

export function AppCardGrid({ apps, onSelectApp, highlightSlug }: Props) {
  if (apps.length === 0) {
    return (
      <Card>
        <Text size="sm" c="dimmed" ta="center" py="md">
          Nenhuma aplicação corresponde aos filtros aplicados.
        </Text>
      </Card>
    )
  }
  return (
    <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="md">
      {apps.map((app) => (
        <AppCard
          key={app.id}
          app={app}
          onSelect={onSelectApp}
          highlight={!!highlightSlug && app.slug === highlightSlug}
        />
      ))}
    </SimpleGrid>
  )
}

export default AppCardGrid
